import { OptionPure } from "./../option-pure";
import { assert } from "@esm-bundle/chai";

import { fixture, html } from "@open-wc/testing";

// eslint-disable-next-line
suite("option-pure", () => {
  test("is defined", () => {
    const el = document.createElement("option-pure");
    assert.instanceOf(el, OptionPure);
  });

  test("renders with textContent as label", async() => {
    const el = await fixture(html`<option-pure value="PL">Poland</option-pure>`);
    console.log(document.body);
    assert.equal(
      el.shadowRoot.innerHTML,
      `
        hello
      `,
    );
  });
});
